// Lib
import { ThemeFile } from 'lib/context/ThemeContext';
import { ButtonPrimaryClasses } from 'src/helpers/Button/buttons/btn--primary';

export const BazaarvoiceReviewSubmissionTheme: ThemeFile = {
  aw: {
    classes: {
      componentWrapperClass: 'col-span-12 lg:grid lg:grid-cols-12',
      headlineContainer: 'col-span-12 text-s md:text-m font-heavy text-theme-text pb-xs',
      thankYouMessaging:
        'col-span-12 text-body text-theme-text font-medium text-theme-body text-body',
      bazaarvoiceContainerWrapper: 'col-start-2 col-span-10 py-m lg:px-m',
      bazaarvoiceImageWrapper: 'w-[100px] lg:inline-block mx-auto lg:mx-0 pr-s mb-s lg:mb-0',
      bazaarvoiceProductContent:
        'inline-block flex flex-col items-center lg:items-start content-center align-middle place-content-center',
      bazaarvoiceProductHeadline: 'text-theme-text text-s mb-xs',
      bazaarvoiceProductWrapper: 'border border-[#b9b9b9] p-s mb-xs lg:flex lg:content-center',
      buttonClass: ButtonPrimaryClasses('aw'),
    },
  },
  rba: {
    classes: {
      componentWrapperClass: 'col-span-12 lg:grid lg:grid-cols-12',
      headlineContainer: 'col-span-12 text-s md:text-m font-heavy text-theme-text pb-xs',
      thankYouMessaging:
        'col-span-12 text-body text-theme-text font-medium text-theme-body text-body',
      bazaarvoiceContainerWrapper: 'col-start-2 col-span-10 py-m lg:px-m',
      bazaarvoiceImageWrapper: 'w-[100px] lg:inline-block mx-auto lg:mx-0 pr-s mb-s lg:mb-0',
      bazaarvoiceProductContent:
        'inline-block flex flex-col items-center lg:items-start content-center align-middle place-content-center',
      bazaarvoiceProductHeadline: 'text-theme-text text-s mb-xs',
      bazaarvoiceProductWrapper: 'border border-[#b9b9b9] p-s mb-xs lg:flex lg:content-center',
      buttonClass: ButtonPrimaryClasses('rba'),
    },
  },
};
